import Collection from "@sourceflow-uk/sourceflow-sdk/collection";

export { default } from "src/pages/newsroom";

export async function getStaticProps() {
  const blogs = (await Collection("blogs"))
    .orderBy("created_at", "desc")
    .getItems();

  return { props: { locale: "de", blogs } };
}
